export const getInitials = (name: string, len = 2): string => {
  const nameParts = name.trim().split(/\s+/g);

  return nameParts
    .slice(0, len)
    .reduce((acc, curr) => acc + (curr[0]?.toUpperCase() || ""), "");
};
